import Bg from "Assets/Common/about_bg.png";

import styled, { css } from "styled-components";
import media from "styled-media-query";

export const MainGrid = styled.section`
  background-color: ${({ theme }) => theme.colors.primary.BG};

  /* ${({ hasBgImg }) =>
    hasBgImg &&
    `
    background-image: url(${Bg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  `} */

  display: grid;
  max-width: 100vw;
  width: 100%;
  grid-template-rows: 72px auto;
  grid-template-areas:
    "headerRight"
    "mainContainer"
    "footer";
  /* height: var(--app-height); */

  ${({ open }) =>
    open &&
    css`
      overflow: hidden;
    `}

  ${media.greaterThan("medium")`
    background-color: ${({ theme }) => theme.colors.neutral.gray2};
    height: fit-content;
    /* row-gap: 30px; */
    grid-template-columns: 1fr;
    grid-template-areas: 
      "headerRight"
      "mainContainer"
      "footer"
      ;
  `}
`;

export const MainContainer = styled.div`
  grid-area: mainContainer;
  z-index: 2;
  justify-self: center;
  /* padding: 0 20px 20px; */
  ${({ open }) =>
    open &&
    css`
      height: var(--app-height);
    `}

  ${media.greaterThan("medium")`
    /* max-width: 1056px; */
  `}
`;

export const GreenFigure = styled.img`
  position: absolute;

  right: 0;
  top: 300px;
`;

export const Footer = styled.footer`
  width: 100%;
  height: 100%;

  padding: 40px 0;

  background-color: ${({ theme }) => theme.colors.neutral.white};

  grid-area: footer;
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  align-items: center;
  gap: 50px;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;

    padding: 0 20px;
  `}
`;

export const Logo = styled.div``;

export const Contact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  p {
    color: #000;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }

  a {
    color: #000;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
`;

export const Socials = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  a {
    color: #000;
    font-family: Sora;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
